export type Blocker = {
  stepId: string; order: number;
  reason: 'no_clip' | 'no_narration' | 'narration_unapproved';
};

const COPY: Record<Blocker['reason'], (n: number) => string> = {
  no_clip: (n) => `Step ${n} has no video clip.`,
  no_narration: (n) => `Step ${n} has no narration.`,
  narration_unapproved: (n) => `Step ${n} narration has not been approved yet.`,
};

/** Steps are zero-ordered internally and one-numbered for people. */
export const describeBlockers = (blockers: Blocker[]): string[] =>
  blockers.map((b) => COPY[b.reason](b.order + 1));
